export const UPDATE_PROCESS_STATEMENT_RTF_REQUEST = 'UPDATE_PROCESS_STATEMENT_RTF_REQUEST';

export const updateProcessStatementRtfRequest = ({ rtfTemplate }) => ({
    type: UPDATE_PROCESS_STATEMENT_RTF_REQUEST,
    payload: {
        rtfTemplate
    },
});
